const UserTypes = {
    MANAGERS: 'managers',
    ALL: 'all',
}

export default UserTypes;